const NAME_ACTION = 'resiliation_silae_client_name'

/**
 * Formulaires ACFE de résiliation HR Sprint / RHP (migration vers Silae).
 *
 * La date souhaitée de résiliation ne peut pas précéder le 1er du mois qui suit
 * la mise en production Silae (M+1). ResiliationSilaeService le vérifie à la
 * soumission ; ici, le calendrier grise les jours antérieurs dès que le mois de
 * mise en production est choisi.
 *
 * Le date picker d'ACF est celui de jQuery UI, greffé sur le jQuery de
 * WordPress : on passe donc par window.jQuery, pas par la copie du bundle.
 *
 * La raison sociale, en lecture seule, suit le code client Cegid : elle est
 * demandée à admin-ajax quand ce code change, ou le code partenaire sur le
 * formulaire partenaires (seuls ses clients sont alors trouvés). Une réponse
 * arrivée après une nouvelle saisie est ignorée. ResiliationSilaeService refait
 * le même rapprochement à la soumission.
 */
export class ResiliationSilae {

  constructor() {
    this.forms = document.querySelectorAll('form.resiliation-silae-form')

    if (!this.forms.length) {
      return
    }

    this.forms.forEach(form => {
      this.initDate(form)
      this.initCompany(form)
    })
  }

  /**
   * @param {HTMLFormElement} form
   */
  initDate(form) {
    const month = form.querySelector('.js-resiliation-production-month select')
    const date = form.querySelector('.js-resiliation-date input.input')

    if (!month || !date) {
      return
    }

    month.addEventListener('change', () => {
      if (window.jQuery && date.classList.contains('hasDatepicker')) {
        window.jQuery(date).datepicker('option', 'minDate', this.getMinDate(month.value))
      }
    })
  }

  /**
   * @param {HTMLFormElement} form
   */
  initCompany(form) {
    const client = form.querySelector('.js-resiliation-client-code input')
    const company = form.querySelector('.js-resiliation-company input')
    const partner = form.querySelector('.js-resiliation-partner-code input')

    if (!client || !company || !window.ajax_url) {
      return
    }

    const load = () => this.loadCompany(client, company, partner)

    client.addEventListener('change', load)
    partner?.addEventListener('change', load)

    if (client.value) {
      load()
    }
  }

  /**
   * @param {HTMLInputElement} client Champ du code client Cegid
   * @param {HTMLInputElement} company Champ de la raison sociale
   * @param {HTMLInputElement|null} partner Champ du code partenaire, formulaire partenaires seulement
   * @returns {Promise<void>}
   */
  async loadCompany(client, company, partner) {
    const code = client.value.trim()
    const partnerCode = partner?.value.trim()

    if (!code || partnerCode === '') {
      this.setCompany(company, '')
      return
    }

    const url = new URL(window.ajax_url.ajax_url)
    url.searchParams.set('action', NAME_ACTION)
    url.searchParams.set('code', code)

    if (partner) {
      url.searchParams.set('partner', partnerCode)
    }

    try {
      const response = await fetch(url)
      const json = response.ok ? await response.json() : null

      if (client.value.trim() === code && partner?.value.trim() === partnerCode) {
        this.setCompany(company, json?.success ? json.data : '')
      }
    } catch {
      // Champ laissé tel quel : la raison sociale est remplie à la soumission
    }
  }

  /**
   * @param {HTMLInputElement} company Champ de la raison sociale
   * @param {string} value
   */
  setCompany(company, value) {
    if (company.value === value) {
      return
    }

    company.value = value
    company.dispatchEvent(new Event('change', {bubbles: true}))
  }

  /**
   * @param {string} value Mois de mise en production, au format YYYY-MM
   * @returns {Date|null} 1er jour du mois suivant
   */
  getMinDate(value) {
    const match = /^(\d{4})-(\d{2})$/.exec(value)

    if (!match) {
      return null
    }

    // Les mois de Date commencent à 0 : le mois M saisi désigne donc M+1
    return new Date(Number(match[1]), Number(match[2]), 1)
  }
}
